import script from "./BacktestView.vue?vue&type=script&setup=true&lang=js"
export * from "./BacktestView.vue?vue&type=script&setup=true&lang=js"

import "./BacktestView.vue?vue&type=style&index=0&id=30b036dc&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-30b036dc"]])

export default __exports__